var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFissstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4672 23.3152L12.0002 17.8272L4.5332 23.3152L7.4002 14.4522L-0.0628052 8.99916H9.15119L12.0002 0.121155L14.8492 8.99916H24.0622L16.6002 14.4522L19.4672 23.3152Z",
    fill: "#cca314"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "cca314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFissstar);
export default __webpack_public_path__ + "static/media/fissstar.007b4aa0b4d74f53845dad96309306f4.svg";
export { ForwardRef as ReactComponent };